import { Model } from '@vuex-orm/core'

class User extends Model {
    // This is the name used as module name of the Vuex Store.
    static entity = 'users'

    // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    static fields () {
        return {
            id: this.attr(null),
            is_superuser: this.boolean(false),

            username: this.attr(''),
            email: this.attr(''),

            referral_code: this.attr(''),

            earnings_current: this.number(0),
            earnings_today: this.number(0),
            earnings_total: this.number(0),
            earnings_payed: this.number(0),
            earnings_referral: this.number(0),

            payout: this.attr(''), //paypal, btc, usdt

            payout_paypal: this.attr(''),
            payout_bitcoin: this.attr(''),
            payout_usdt: this.attr(''),

            notifications_withdraw: this.boolean(false),
            notifications_weekly_report: this.boolean(false),
            notifications_password_change: this.boolean(false),
            notifications_news: this.boolean(false),
        }
    }
}

class Transaction extends Model {
    static entity = 'transactions'

    static fields () {
        return {
            id: this.attr(null),
            status: this.attr(''),
            payout: this.attr(''),

            amount: this.number(0),

            created: this.attr(''),
            completed: this.attr('')
        }
    }
}

class Referral extends Model {
    static entity = 'referrals'

    static fields () {
        return {
            id: this.attr(null),
            status: this.attr(''),
            email: this.attr(''),

            ip: this.attr(''),

            amount: this.number(0),

            referral: this.attr(null),

            created: this.attr(''),
        }
    }
}

class News extends Model {
    static entity = 'news'

    static fields () {
        return {
            id: this.attr(null),

            version: this.number(1.0),
            os: this.attr(''),

            title: this.attr(''),
            body: this.attr(''),

            created: this.attr('')
        }
    }
}

class Device extends Model {
    static entity = 'device'

    static fields () {
        return {
            id: this.attr(null),

            version: this.number(1.0),
            os: this.attr(''),

            ip: this.attr(''),

            online: this.attr(null),

            created: this.attr('')
        }
    }
}

class Client extends Model {
    static entity = 'clients'

    static fields () {
        return {
            id: this.attr(null),

            user_id: this.uid(''),

            ipv4: this.attr(''),
            ipv6: this.attr(''),
            os: this.attr(''),
            version: this.attr(''),
            app_version: this.attr(''),

            country: this.attr(''),
            region: this.attr(''),
            city: this.attr(''),

            server: this.attr(''),
        }
    }
}



export {
    User, Transaction, Referral, News, Device, Client
}
